import { findFocusTargetOutside } from "@faire/slate/lib/focusUtils";
import React, { useCallback } from "react";

/**
 * Returns a stable callback that moves focus to the next focusable element
 * outside `ref.current` (falling back to the previous focusable). Useful when
 * a component is about to remove itself or one of its descendants from the
 * DOM and needs to anchor focus somewhere intentional.
 */
export const useFocusTargetOutside = <E extends HTMLElement = HTMLElement>(
  ref: React.RefObject<E | null>
) =>
  useCallback(() => {
    if (ref.current) {
      findFocusTargetOutside(ref.current)?.focus();
    }
  }, [ref]);
